<template>
  <div
    :style="
      !this.$store.getters.iframeColidee
        ? 'margin-top:-30px;margin-bottom:30px'
        : 'margin-bottom:60px'
    "
    :class="!this.$store.getters.iframeColidee ? 'bloc p-3' : 'p-3'"
  >
    <div class="field">
      <label v-if="this.$store.getters.iframeColidee" class="label">{{
        $t("sondage.etat.colidee")
      }}</label>
      <label v-else class="label">{{ $t("sondage.etat") }}</label>
      <div class="hr-grey" />
      <div class="control" v-bind:class="{ 'is-loading': isLoading }">
        <label class="radio">
          <div
            @click.prevent="checkStateHasQuestions()"
            :style="
              isChecked_STATE
                ? 'background-color:green; padding:10px;color:white'
                : 'padding:10px; color:black'
            "
          >
            <input
              type="radio"
              name="STATE"
              value="1"
              v-bind:checked="isChecked_STATE"
              @click="onFormChange"
            />
            {{ $t("sondage.etat_ouvert") }}
          </div>
        </label>

        <label class="radio">
          <div
            :style="
              !isChecked_STATE
                ? isLoading
                  ? 'background-color:none; padding:10px;color:#000'
                  : 'background-color:red; padding:10px;color:#fff'
                : 'padding:10px;'
            "
          >
            <input
              type="radio"
              value="0"
              name="STATE"
              v-bind:checked="!isChecked_STATE"
              @click="onFormChange"
              v-bind="{ disabled: isLoading }"
            />
            {{ $t("sondage.etat_ferme") }}
          </div>
        </label>
      </div>
    </div>

    <div class="field">
      <label class="label">{{ $t("sondage.name") }}*</label>
      <div class="control" v-bind:class="{ 'is-loading': isLoading }">
        <input
          :required="sondage_name"
          :value="sondage_name"
          name="NAME"
          @input="onFormChange"
          class="input"
          type="text"
          :placeholder="$t('sondage.name')"
        />
      </div>
    </div>

    <div class="field">
      <label class="label">{{ $t("sondage.client") }}</label>
      <div class="control" v-bind:class="{ 'is-loading': isLoading }">
        <input
          :value="sondage_client"
          name="CLIENT"
          @input="onFormChange"
          class="input"
          type="text"
          :placeholder="$t('sondage.client')"
          v-bind="{ disabled: isLoading }"
        />
      </div>
    </div>

    <div class="field">
      <label class="label">{{ $t("sondage.evenement") }}</label>
      <div class="control" v-bind:class="{ 'is-loading': isLoading }">
        <input
          :value="sondage_evenement"
          name="EVENEMENT"
          @input="onFormChange"
          class="input"
          type="text"
          :placeholder="$t('sondage.evenement')"
          v-bind="{ disabled: isLoading }"
        />
      </div>
    </div>

    <!-- Champ Open et close -->
    <div class="field">
      <label class="label">{{ $t("sondage.openAt") }}</label>
      <div class="control" v-bind:class="{ 'is-loading': isLoading }">
        <b-datepicker
          :max-date="modelCloseAt"
          :locale="this.$store.getters.langue"
          :mobile-modal="false"
          v-model="modelOpenAt"
          :placeholder="$t('sondage.openAt')"
          expanded
          editable
          :first-day-of-week="1"
        ></b-datepicker>
      </div>
    </div>

    <div class="field">
      <label class="label">{{ $t("sondage.closeAt") }}</label>
      <b-datepicker
        :min-date="modelOpenAt"
        :locale="this.$store.getters.langue"
        :mobile-modal="false"
        v-model="modelCloseAt"
        :placeholder="$t('sondage.closeAt')"
        expanded
        editable
        :first-day-of-week="1"
      ></b-datepicker>
      <div
        v-if="!isLoading && $store.getters.open_at < new Date()"
        style="margin-top:5px;"
      >
        <b-switch
          style="vertical-align:middle;"
          v-model="closeSondage"
          type="is-warning"
        /><span style="margin-left:-5px;font-size:12px;">{{
          $t("sondage.close")
        }}</span>
      </div>
    </div>

    <div class="field">
      <label class="label">{{ $t("sondage.type") }}</label>
      <div class="input" v-bind:class="{ 'is-loading': isLoading }">
        <label class="radio">
          <input
            type="radio"
            value="replay"
            name="TYPE"
            v-bind:checked="isChecked_REPLAY"
            @click="onFormChange"
            v-bind="{ disabled: isLoading }"
          />
          {{ $t("sondage.type_replay") }}
        </label>
        <label style="margin-left:10px;" class="radio">
          <input
            type="radio"
            value="block"
            name="TYPE"
            v-bind:checked="isChecked_BLOCK"
            @click="onFormChange"
            v-bind="{ disabled: isLoading }"
          />
          {{ $t("sondage.type_block") }}
        </label>
      </div>
      <label v-if="isChecked_BLOCK && !this.$store.getters.iframeColidee">
        <b-checkbox
          style="vertical-align:middle;"
          v-model="showResultsClient"
        /><span style="margin-left:-10px;">{{
          $t("popup_sondage_show_results")
        }}</span></label
      >
    </div>

    <div class="field">
      <label class="label">{{ $t("sondage.background") }}</label>
      <div
        class="input"
        style="display:flex"
        v-if="!this.$store.state.sondage.has_background && !this.file"
      >
        <b-upload
          style="margin-left:-8px;"
          accept="image/png, image/gif, image/jpeg, video/mp4"
          v-model="file"
          @input="checkFileSize()"
        >
          <p class="file-label">
            <img
              style="margin-left:5px;margin-right:10px;width:18px; height:18px;"
              src="~@/assets/img/icons/add_photo.png"
              alt="add-photo"
            /><span>{{ $t("sondage.file") }}</span>
          </p>
        </b-upload>
      </div>

      <div
        style="font-size:12px"
        v-if="this.$store.state.sondage.has_background || this.file"
      >
        <b-icon pack="fas" icon="check-square" size="is-small"></b-icon>
        {{ $t("sondage.file_ok") }}
        <span
          style="margin-left:65px;font-size:16px;cursor:pointer;"
          @click="removeFile()"
        >
          <b-icon pack="fas" icon="trash-alt" size="is-small"></b-icon>
        </span>
      </div>
      <img
        style="width:250px"
        v-if="this.$store.state.sondage.has_background"
        :src="this.url_sondage + this.$store.state.sondage.has_background"
      />
      <div style="width:250px;" id="preview">
        <img v-if="url" :src="url" />
      </div>
    </div>
    <!-- Choose language fr / en / es -->
    <div class="field">
      <label class="label">{{ $t("popupadmin.reinitialise.language") }}</label>
      <p style="font-size:10px;">
        {{ $t("popupadmin.choosen.language") }}
        <span
          style="font-weight:bold; color:black; font-size:10px;"
          v-for="(language, index) in this.sondage_languages"
          :key="index"
          >{{ language }}{{ " " }}</span
        >
      </p>
      <p
        v-if="!this.sondage_languages.length"
        class="texte_petit"
        style="color:red; font-size:12px;"
      >
        {{ $t("sondage.chosen-language") }}
      </p>
      <div style="max-width:100px;height:40px;" class="columns is-mobile">
        <div class="column is-one-quarters-mobile">
          <img
            :class="
              this.sondage_languages.includes('fr') ? 'selected-flag' : 'flag'
            "
            @click="optionFlag('FR')"
            class="icon-flag"
            src="~@/assets/img/flag_translation/fr-2.png"
          />
        </div>
        <!-- EN -->
        <div class="column is-one-quarters-mobile">
          <img
            :class="
              this.sondage_languages.includes('en') ? 'selected-flag' : 'flag'
            "
            @click="optionFlag('EN')"
            class="icon-flag"
            src="~@/assets/img/flag_translation/en-2.png"
          />
        </div>
        <!-- ES -->
        <div class="column is-one-quarters-mobile">
          <img
            :class="
              this.sondage_languages.includes('es') ? 'selected-flag' : 'flag'
            "
            @click="optionFlag('ES')"
            class="icon-flag"
            src="~@/assets/img/flag_translation/es-2.png"
          />
        </div>
        <!-- DE -->
        <div class="column is-one-quarters-mobile">
          <img
            :class="
              this.sondage_languages.includes('de') ? 'selected-flag' : 'flag'
            "
            @click="optionFlag('DE')"
            class="icon-flag"
            src="~@/assets/img/flag_translation/de-2.png"
          />
        </div>
      </div>
    </div>
    <!-- presentation field -->
    <div class="field">
      <label class="label">{{ $t("sondage.presentation") }}</label>
      <p class="texte_petit">{{ $t("sondage.presentation.dessous") }}</p>
      <div class="control" v-bind:class="{ 'is-loading': isLoading }">
        <textarea
          :value="sondage_presentation"
          name="PRESENTATION"
          @input="onFormChange"
          type="textarea"
          class="textarea"
          maxlength="2000"
          rows="2"
          :placeholder="$t('sondage.placeholder.presentation')"
          v-bind="{ disabled: isLoading }"
        ></textarea>
      </div>
    </div>
    <!-- thanks field -->
    <div class="field">
      <label class="label">{{ $t("sondage.thanks") }}</label>
      <p class="texte_petit">{{ $t("sondage.thanks.dessous") }}</p>
      <div class="control" v-bind:class="{ 'is-loading': isLoading }">
        <textarea
          :value="sondage_thanks"
          name="THANKS"
          @input="onFormChange"
          type="textarea"
          class="textarea"
          maxlength="200"
          rows="2"
          :placeholder="$t('sondage.placeholder.thanks')"
          v-bind="{ disabled: isLoading }"
        ></textarea>
      </div>
    </div>
    <div
      v-if="
        this.$store.state.sondage.fields.results_count && stateOnlinePreview
      "
    >
      <b-message type="is-danger" style="margin-bottom:10px;font-size:12px;">{{
        $t("sondage.previewAndVotes.text")
      }}</b-message>
    </div>
    <div>
      <div v-if="this.sondage_languages.length > 1 && showWarningTranslation">
        <b-message
          type="is-danger"
          style="margin-bottom:10px;font-size:12px;"
          >{{ $t("popupSondage.warningTranslation.text") }}</b-message
        >
        <div class="has-text-right">
          <button
            class="button is-danger"
            @click="showWarningTranslationFunction()"
          >
            {{ $t("popupSondage.understandButton") }}
          </button>
        </div>
      </div>
      <div v-else>
        <div class="has-text-right">
          <button
            :disabled="
              this.sondage_languages.length && sondage_name && !loading
                ? false
                : true
            "
            class="button is-primary"
            @click="SubmitForm()"
          >
            {{ $t("button.sauvegarder") }}
          </button>
          <br /><br /><br />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "Parameters",
  data() {
    return {
      file: null,
      url_sondage: process.env.URL_MEDIA,
      query: "",
      pending: false,
      erreur_email: false,
      errors: [],
      data: [],
      shares: [],
      loading: false,
      selectedCountryFr: true,
      selectedCountryEn: false,
      selectedCountryEs: false,
      selectedCountryDe: false,
      showWarningTranslation: false,
      errorName: true,
      url: "",
      stateBeforeSave: true
    };
  },
  mounted() {
    window.scrollTo(0, 0);
    let message = {
      height: document.body.scrollHeight
    };
    window.top.postMessage(message, "*");
  },
  watch: {
    sondages() {
      this.$store.commit("ADMIN_ACTIVE_COMPONENTS", {
        cardList: true,
        parameters: false
      });
    },
    sondage_languages() {
      if (this.sondage_languages.length > 1) {
        this.showWarningTranslation = true;
      }
      if (!this.sondage_languages.length) {
        this.$buefy.toast.open({
          type: "is-danger",
          message: this.$i18n.t("sondage.chosen-language")
        });
      }
    }
  },
  computed: {
    ...mapGetters([
      "sondages",
      "sondage_name",
      "sondage_id",
      "sondage_evenement",
      "sondage_client",
      "sondage_shares",
      "sondage_state",
      "sondage_thanks",
      "sondage_presentation",
      "sondage_languages",
      "isLoading"
    ]),
    modelOpenAt: {
      get: function() {
        return this.$store.getters.open_at !== null
          ? this.$store.getters.open_at
          : null;
      },
      set: function(newValue) {
        this.$store.commit("SET_OPEN_AT", newValue);
      }
    },
    modelCloseAt: {
      get: function() {
        return this.$store.getters.close_at !== null
          ? this.$store.getters.close_at
          : null;
      },
      set: function(newValue) {
        this.$store.commit("SET_CLOSE_SONDAGE", 0);
        this.$store.commit("SET_CLOSE_AT", newValue);
      }
    },
    closeSondage: {
      get: function() {
        if (this.$store.getters.getCloseSondage === 1) return true;
        else return false;
      },
      set: function(newValue) {
        if (newValue === true) {
          this.$store.commit("SET_CLOSE_SONDAGE", 1);
          this.$store.commit("SET_CLOSE_AT", new Date());
        }
        else {
          this.$store.commit("SET_CLOSE_SONDAGE",0);
          this.$store.commit("SET_CLOSE_AT", null);
        }

      }
    },
    showResultsClient: {
      get: function() {
        if (this.$store.getters.showResultsClient === 1) return true;
        else return false;
      },
      set: function(newValue) {
        if (newValue === true) {
          this.$store.commit("SHOW_RESULTS_CLIENT", 1);
        } else {
          this.$store.commit("SHOW_RESULTS_CLIENT", 0);
        }
      }
    },
    isChecked_STATE() {
      if (this.$store.state.sondage.fields.state == 1) {
        return true;
      } else {
        return false;
      }
    },
    isChecked_REPLAY() {
      if (this.$store.state.sondage.fields.type == "replay") {
        this.$store.commit("SHOW_RESULTS_CLIENT", 0);
        return true;
      } else {
        return false;
      }
    },
    isChecked_RELOG() {
      if (this.$store.state.sondage.fields.type == "relog") {
        return true;
      } else {
        return false;
      }
    },
    isChecked_BLOCK() {
      if (this.$store.state.sondage.fields.type == "block") {
        return true;
      } else {
        return false;
      }
    }
  },
  created() {
    this.$store.commit("RAZ_RESULTS_COUNT");
    let message = {
      height: document.body.scrollHeight
    };
    window.top.postMessage(message, "*");
  },
  methods: {
    // show warning translation
    showWarningTranslationFunction() {
      this.showWarningTranslation = false;
    },
    // translation functions
    optionFlag(lang) {
      switch (lang) {
        case "FR":
          this.selectedCountryFr = !this.selectedCountryFr;
          this.$store.commit("UPDATE_LANGUAGE_FR", this.selectedCountryFr);
          break;
        case "EN":
          this.selectedCountryEn = !this.selectedCountryEn;
          this.$store.commit("UPDATE_LANGUAGE_EN", this.selectedCountryEn);
          break;
        case "ES":
          this.selectedCountryEs = !this.selectedCountryEs;
          this.$store.commit("UPDATE_LANGUAGE_ES", this.selectedCountryEs);
          break;
        case "DE":
          this.selectedCountryDe = !this.selectedCountryDe;
          this.$store.commit("UPDATE_LANGUAGE_DE", this.selectedCountryDe);
          break;
      }
    },
    checkStateHasQuestions() {
      if (!this.$store.state.sondage.fields.state)
        this.stateOnlinePreview = true;
      if (this.$store.state.sondage.has_questions === 0) {
        this.$store.commit("UPDATE_SONDAGE_STATE", 0);
        this.$buefy.toast.open({
          type: "is-danger",
          message: this.$i18n.t("toast.add_questions")
        });
      } else if (this.$store.state.sondage.has_questions > 0) {
        this.$store.commit("UPDATE_SONDAGE_STATE", 1);
      }
    },
    checkFileSize() {
      if (this.file && this.file.size > 6000000) {
        this.file = null;
        this.$buefy.toast.open({
          type: "is-danger",
          message: this.$i18n.t("toast.fichier_trop_lourd")
        });
      }
      this.url = URL.createObjectURL(this.file);
    },
    removeFile() {
      this.$store.commit(`UPDATE_HAS_BACKGROUND`, null);
      this.file = null;
      this.url = "";
    },
    SubmitForm(evt) {
      this.loading = true;
      if (this.$store.state.sondage.isEditing) {
        this.$store.dispatch("update_sondage", this.file);
      } else {
        this.$store.dispatch("create_new_sondage", this.file);
      }
      this.file = null;
    },
    onFormChange(evt) {
      if (evt.target.name === "NAME" && evt.target.value !== "") {
        this.errorName = false;
      } else {
        this.errorName = true;
      }
      this.$store.commit(`UPDATE_SONDAGE_${evt.target.name}`, evt.target.value);
    }
  }
};
</script>
<style scoped>
.input {
  background: #eeeeee !important;
  border-radius: 0px;
  box-shadow: none;
  font-size: 12px;
}
.input::placeholder {
  color: grey;
}
.input:invalid {
  border: red solid 1px;
}
label {
  font-size: 12px;
}
.flag {
  opacity: 0.2;
  cursor: pointer;
}
.selected-flag {
  opacity: 1;
  cursor: pointer;
}
.button {
  color: white;
  border-radius: 4px;
  font-size: 12px;
}
.column {
  padding-bottom: 0px !important;
}
.textarea {
  background: #eeeeee !important;
  border-radius: 0px;
  box-shadow: none;
  font-size: 12px;
}
.textarea::placeholder {
  color: grey;
}
.p-1 {
  padding: 10px;
}
.hr-grey {
  height: 1px;
  width: 100%;
  background: grey;
}
.texte_petit {
  font-size: 9px;
}
.icon-flag {
  vertical-align: middle;
  min-height: 15px;
  min-width: 20px;
  margin-right: 8px;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/sondage/Parameters.vue